import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ValidationService} from '@dcp/configurator';
import {ConfiguratorProductService} from '@app/product/configurator/services/configurator-product.service';
import {Product} from '@spartacus/core';
import {CartDecoratorErrorHandlingService} from '@app/checkout/services/cart-decorator-error-handling.service';
import {TransactionTextsService} from '../services/transaction-texts.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {TransactionTypeTexts} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';

@UntilDestroy()
@Component({
  selector: 'dcp-field-quantity',
  templateUrl: './formly-field-quantity.component.html',
  styleUrls: ['./formly-field-quantity.component.scss'],
})
export class FormlyFieldQuantityComponent extends FieldType implements OnInit {
  public variantProduct$: Observable<Product> = this.configuratorProductService.getVariant$();
  public product: Product;

  public showErrorLocal: boolean = false;
  public isQuantityInputReadOnly: boolean;

  public transactionTypeTexts$: Observable<TransactionTypeTexts>;

  public errorMessage: string = 'configurator.error.noError';
  public valueState$ = new BehaviorSubject('Standard');

  constructor(
    public validationService: ValidationService,
    private configuratorProductService: ConfiguratorProductService,
    private cartDecoratorErrorHandlingService: CartDecoratorErrorHandlingService,
    private cdr: ChangeDetectorRef,
    private transactionTextsService: TransactionTextsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.transactionTypeTexts$ = this.transactionTextsService.getTransactionTypeTexts$();
    this.subscribeToRequestErrors();
    this.isQuantityInputReadOnly = this.props.min === this.props.max;
    if (!this.formControl.value) {
      this.formControl.setValue(this.field.defaultValue || 1);
    }
    this.validateInput();
  }

  getExpectedValue(validatorName: string) {
    if (this.formControl?.errors && this.formControl?.errors[validatorName]) {
      return this.formControl.errors[validatorName][validatorName];
    }
    return '';
  }

  subscribeToRequestErrors() {
    this.cartDecoratorErrorHandlingService
      .quantityErrorSubject$()
      .pipe(untilDestroyed(this))
      .subscribe((se) => {
        if (se) {
          this.formControl.setErrors({outOfBounds: true});
        }
        this.cdr.detectChanges();
      });
  }

  onStepInputChange(event: CustomEvent): void {
    this.formControl.setValue(event.detail.value);
    this.validateInput();
  }

  onValueStateChange(event: CustomEvent): void {
    event.preventDefault();
  }

  validateInput(): void {
    this.setValueState();
    this.setErrorMessage();
  }

  setValueState(): void {
    this.valueState$.next(this.hasError() ? 'Error' : 'Standard');
  }

  setErrorMessage(): void {
    if (this.hasError()) {
      const error = Object.keys(this.formControl.errors)[0];
      this.errorMessage =  `configurator.quantity.${this.fieldNameParser(error)}`;
    } else {
      this.errorMessage =  'configurator.error.noError';
    }
  }

  hasError(): boolean {
    return !!this.formControl.errors;
  }

  getTranslationValues(): number {
    const translation = this.errorMessage;
    if (translation === 'configurator.quantity.minimum') {
      return this.props.min;
    }
    if (translation === 'configurator.quantity.maximum') {
      return this.props.max;
    }
    if (translation === 'configurator.quantity.step') {
      return this.field.props?.step || 1;
    }
    return null;
  }

  private fieldNameParser(field: string): string {
    switch (field) {
      case 'min':
        return 'minimum';
      case 'pattern':
        return 'onlyWholeNumbers';
      case 'wrongInterval':
        return 'step';
      case 'max':
        return 'maximum';
      default:
        return field;
    }
  }
}
